import { useEffect, type ReactNode } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { clearPendingJoin, joinPath, joinTokenFromPath, peekPendingJoin, rememberPendingJoin } from './pendingJoin';

/** Takes the pending token out of storage, then goes to it, so the trip happens once. */
function ConsumePendingJoin({ token }: { token: string }) {
  const navigate = useNavigate();
  useEffect(() => {
    clearPendingJoin();
    navigate(joinPath(token), { replace: true });
  }, [navigate, token]);
  return null;
}

/**
 * Carries an invite link across sign-in (see `pendingJoin.ts`). The token is
 * remembered only while signed out: a signed-in `/join/<token>` already shows
 * the join page, and remembering it there would send "Not now" straight back.
 * `signedIn` is null until Stytch has initialized.
 */
export function PendingJoinGate({ signedIn, children }: { signedIn: boolean | null; children: ReactNode }) {
  const location = useLocation();
  const joinToken = joinTokenFromPath(location.pathname);
  useEffect(() => {
    if (signedIn === false && joinToken) rememberPendingJoin(joinToken);
  }, [signedIn, joinToken]);
  const pending = signedIn === true && location.pathname === '/' ? peekPendingJoin() : null;
  if (pending) return <ConsumePendingJoin token={pending} />;
  return <>{children}</>;
}
